import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { historialEntregasHologramas } from '../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import { v4 as uuidv4 } from 'uuid';
import { actualizarClientesDev, actualizarRelacionesDev, buscarSolicitudByFolio, obtenerTodasRelacionesDev, obtenerTodosClientesDev } from '../../../redux/DuckUsuarioDeveloper/SolicitudesDevDuck';
import ModalEntregasParcialesComponent from './ModalEntregasParcialesComponent';

const SolicitudesDevComponent = () => {

    const dispatch = useDispatch()
    const solicitudesDev = useSelector(store => store.UsuarioDeveloper.solicitudesDev)

    const [busqueda, setBusqueda] = React.useState('')




    const [openModal, setOpenModal] = React.useState(false)
    const [openModalEntregas, setOpenModalEntregas] = React.useState(false)
    const [informacionSolicitud, setInformacionSolicitud] = React.useState('')

    const columns = [
        { field: 'numAsociado', headerName: 'No. asociado', headerAlign: 'center', width: 120 },
        { field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 295 },
        { field: 'folio', headerName: 'Folio', headerAlign: 'center', width: 120 },
        { field: 'tipoSolicitud', headerName: 'Tipo Solicitud', headerAlign: 'center', width: 405 },
        { field: 'estatus', headerName: 'Estatus', headerAlign: 'center', width: 200 },
        {
            field: 'accion', headerName: 'Acción', headerAlign: 'center', width: 150,
            renderCell: (params) => (
                <button className={`btn btn-outline-success`} onClick={() => CambioSolicitud(params.row)} >Cambio</button>
            )
        },
    ]
    const CambioSolicitud = (params) => {
        setOpenModal(true)
        setInformacionSolicitud(params)
    }
    const estatusGenerar = (idestatusdesolicitudes) => {
        let estatus = ''
        if (idestatusdesolicitudes == 1) estatus = 'Borrador'
        if (idestatusdesolicitudes == 2) estatus = 'Enviada'
        if (idestatusdesolicitudes == 3) estatus = 'Proceso'
        if (idestatusdesolicitudes == 4) estatus = 'Aceptada'
        if (idestatusdesolicitudes == 5) estatus = 'Devuelta'
        if (idestatusdesolicitudes == 6) estatus = 'Recibida'
        if (idestatusdesolicitudes == 7) estatus = 'Documentacion'
        if (idestatusdesolicitudes == 8) estatus = 'Cancelada'
        return estatus
    }
    const rows = []

    solicitudesDev?.[0]?.map(anexo => {

        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerosocio, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Solicitud Registro', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc01_solicitudregistro: anexo?.idfc01_solicitudregistro
        })
    })
    solicitudesDev?.[1]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Marca e imagen', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc05_solicitudusomarcaeimagen: anexo?.idfc05_solicitudusomarcaeimagen
        })
    })
    solicitudesDev?.[2]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Registro de predio', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc06_registromaguey: anexo?.idfc06_registromaguey
        })
    })
    solicitudesDev?.[3]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Renovacion de certificado', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc08_renvacioncertificado: anexo?.idfc08_renvacioncertificado
        })
    })
    solicitudesDev?.[4]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrecliente,
            folio: anexo?.folio, tipoSolicitud: 'Exportación', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc09_solicitudcertificado: anexo?.idfc09_solicitudcertificado
        })
    })
    solicitudesDev?.[5]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrecliente,
            folio: anexo?.folio, tipoSolicitud: 'Notificación de traslado', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc30_notificaciontrasladodepr: anexo?.idfc30_notificaciontrasladodepr
        })
    })
    solicitudesDev?.[6]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Solicitud de seguimiento', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc31_solicitudseguimiento: anexo?.idfc31_solicitudseguimiento
        })
    })
    solicitudesDev?.[7]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrecliente,
            folio: anexo?.folio, tipoSolicitud: 'Solicitud de envasado nacional', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc33_solicitudenvasadonaciona: anexo?.idfc33_solicitudenvasadonaciona
        })
    })
    solicitudesDev?.[8]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Notificacion y suspencion', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc34_notificacionsuspencion: anexo?.idfc34_notificacionsuspencion
        })
    })
    solicitudesDev?.[9]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Servicios varios', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc35_notificacionserviciosvar: anexo?.idfc35_notificacionserviciosvar
        })
    })
    solicitudesDev?.[10]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Solicitud de actualizacion', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc36_solicitudactualizacion: anexo?.idfc36_solicitudactualizacion
        })
    })
    solicitudesDev?.[11]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Adquisicion de hologramas', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc40_solicitudadquisicionholo: anexo?.idfc40_solicitudadquisicionholo
        })
    })
    solicitudesDev?.[12]?.map(anexo => {
        rows.push({
            id: uuidv4(), numAsociado: anexo?.numerocliente, razonSocial: anexo?.nombrerazonsocial,
            folio: anexo?.folio, tipoSolicitud: 'Solicitud para bebidas', estatus: estatusGenerar(anexo?.idestatusdesolicitudes),
            idfc41_solicitudparabebidasconm: anexo?.idfc41_solicitudparabebidasconm
        })
    })

    const historialEntregas = async (params) => {
        await dispatch(historialEntregasHologramas(params.row.idloginfc40_solicitudadquisicionholo))
        setOpenModalEntregas(true)
    }

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <GridToolbarQuickFilter style={{ backgroundColor: '#F8F9F9', width: '100%' }} placeholder='Búsqueda...' />
            </Box>
        );
    }

    const buscarSolicitud = async () => {
        await dispatch(buscarSolicitudByFolio(busqueda))
    }

    const actualizar = async () => {
        let clientes = await dispatch(obtenerTodosClientesDev())
        console.log('los clientes son ', clientes.payload)
        await dispatch(actualizarClientesDev(clientes.payload))
    }
    const actualizarRelaciones = async () => {
        let relaciones = await dispatch(obtenerTodasRelacionesDev())
        console.log('las relaciones es  ', relaciones.payload)
        await dispatch(actualizarRelacionesDev(relaciones.payload))
    }

    return (
        <div className="container">
            <div className='row'>
                <div className='col-11'>
                    <div className="form-floating mb-2">
                        <input type="text" min="0" className={`form-control `} id="floatingInput" value={busqueda} onChange={e => setBusqueda(e.target.value)} />
                        <label htmlFor='floatingInput'>Ingrese un Folio:</label>
                    </div>
                </div>
                <div className='col-1'>
                    <button onClick={() => buscarSolicitud()} className='btn btn-outline-success'>Buscar Folio</button>
                </div>
            </div>


            <Box sx={{ height: 400, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    disableColumnMenu={true}
                    components={{ Toolbar: QuickSearchToolbar }}
                    pageSize={10}
                    sx={{
                        boxShadow: 0,
                        color: 'black',
                        border: 0,
                        backgroundColor: 'white',
                        '& .MuiDataGrid-cell': {
                            display: 'block',
                            position: 'relative',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: 'purple',
                            color: 'white',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                            height: '20px'
                        }
                    }}
                />
            </Box>
            {openModal &&
                <ModalEntregasParcialesComponent informacionSolicitud={informacionSolicitud} setOpenModal={setOpenModal} openModal={openModal} />
            }

            {/*
             * Estos dos botones es para actualizar lo que el numero de socio a 5 digotos y tambien para que en la tabla de 
             * relaciones se actuelice a 5 digitos 
             */}
            <div className='col-1'>
                <button onClick={() => actualizar()} className='btn btn-outline-success'>Actualizar Numero Cliente</button>
                <button onClick={() => actualizarRelaciones()} className='btn btn-outline-success'>Actualizar Relaciones Cliente</button>
            </div>
        </div>
    );

};
export default SolicitudesDevComponent